<template>
  <section
    id="hero"
    class="hh-hero"
  >
    <div
      class="hh-hero__aurora"
      aria-hidden="true"
    />

    <v-container class="hh-hero__container px-4">
      <v-row
        align="center"
        class="fill-height"
      >
        <v-col
          cols="12"
          lg="8"
          xl="7"
        >
          <p class="hh-hero__kicker mb-6">
            Hacker Hang is an AI media company.
          </p>

          <h1 class="hh-display mb-8">
            We build the agents, apps, and platforms
            <span class="hh-gradient-text">that make media move.</span>
          </h1>

          <p class="hh-lead mb-10">
            AI agent builds, React Native development, and social platforms for
            teams that want to ship, plus two products of our own: VividMotion and Total Chaos.
          </p>

          <div class="d-flex flex-wrap hh-hero__actions">
            <base-action-link
              :to="{ name: 'Products' }"
              accent
            >
              See our products
            </base-action-link>
          </div>
        </v-col>

        <v-col
          class="hidden-md-and-down"
          cols="12"
          lg="4"
        >
          <div class="hh-hero__stack">
            <div
              v-for="line in stack"
              :key="line.label"
              class="hh-hero__line"
            >
              <span
                class="hh-hero__swatch"
                :style="{ background: line.color }"
              />
              <span class="hh-hero__label">{{ line.label }}</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div class="hh-spectrum-bar" />
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    data: () => ({
      stack: [
        { label: 'AI agents', color: 'var(--hh-violet)' },
        { label: 'React Native apps', color: 'var(--hh-sky)' },
        { label: 'Social platforms', color: 'var(--hh-magenta)' },
        { label: 'VividMotion', color: 'var(--hh-cyan)' },
        { label: 'Total Chaos', color: 'var(--hh-yellow)' },
      ],
    }),
  }
</script>

<style lang="sass">
  .hh-hero
    position: relative
    overflow: hidden
    min-height: calc(100vh - 120px)
    display: flex
    flex-direction: column

    @media (max-width: 959px)
      min-height: auto

    &__container
      flex: 1
      padding-top: 96px
      padding-bottom: 96px

      @media (max-width: 959px)
        padding-top: 64px
        padding-bottom: 64px

    &__aurora
      position: absolute
      inset: -20% -10% auto auto
      width: 70vw
      height: 70vw
      max-width: 900px
      max-height: 900px
      pointer-events: none
      background: radial-gradient(closest-side, rgba(16, 0, 232, .55), rgba(106, 15, 216, .35) 45%, rgba(232, 58, 240, .18) 70%, transparent 100%)
      filter: blur(40px)
      opacity: .9

    &__kicker
      font-size: 1rem
      font-weight: 500
      color: var(--hh-cyan)

    &__actions
      gap: 28px

    &__stack
      display: flex
      flex-direction: column
      gap: 14px
      padding-left: 24px
      border-left: 1px solid var(--hh-line)

    &__line
      display: flex
      align-items: center
      gap: 14px

    &__swatch
      width: 34px
      height: 12px
      border-radius: 3px
      flex: none

    &__label
      font-size: 1.05rem
      color: var(--hh-muted)
</style>
